
import logoHeardfullsmall from './images/logoHeardfullsmall.png';

const StarActiveIcon = (props) => {
  return (
    <img src={logoHeardfullsmall} width={22} height={21} {...props} alt="fireHeard" />    
  )
}

export default StarActiveIcon